var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPathGroupClipOutlined = function SvgHtlPathGroupClipOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlPathGroupClipOutlined_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 .005H0V16h16V.005Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlPathGroupClipOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.408 12.656a1.5 1.5 0 0 1-.424-1.011v-.625a.5.5 0 0 1 1 0v.62c.01.272.173.4.484.4 1-.031 10.683 0 11.1 0h.014c.119 0 .391-.057.48-.49v-.018c0-.1 0-.311-.014-.482a.5.5 0 1 1 .999-.051c.037.273.028.55-.025.82a1.494 1.494 0 0 1-1.467 1.22c-.316 0-10.085-.03-11.054 0h-.064a1.422 1.422 0 0 1-1.029-.383Zm10.967-2.853A4.38 4.38 0 0 0 8 5.428a4.38 4.38 0 0 0-4.375 4.375.5.5 0 0 1-1 0 5.382 5.382 0 0 1 5.376-5.375 5.38 5.38 0 0 1 5.375 5.375.5.5 0 0 1-1.001.004v-.004Zm-4.972-5.8a.4.4 0 0 1-.4-.4V3.41a.405.405 0 0 1 .4-.4h1.193a.405.405 0 0 1 .4.4v.193a.405.405 0 0 1-.4.4H7.403Z"
  }))));
};
export default SvgHtlPathGroupClipOutlined;